import RUF from "../../../util/redux";

export function personalFormerAddressOwnership(state, action) {
  const applicantsArray = state.model.applicants;
  const currentIndex = parseInt(state.meta.currentApplicant);

  return RUF.updateObject(state, {
    model: RUF.updateObject(state.model, {
      applicants: [
        ...applicantsArray.slice(0, currentIndex),
        RUF.updateObject(applicantsArray[currentIndex], {
          formerAddress: RUF.updateObject(applicantsArray[currentIndex].formerAddress, {
            ownership: action.payload
          })
        }),
        ...applicantsArray.slice(currentIndex+1)
      ]
    })
  });
}
